import React, { useState, useEffect } from "react";

function InstallButton() {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleBeforeInstallPrompt = (e) => {
            // Prevent Chrome from automatically showing the install prompt
            e.preventDefault();
            setDeferredPrompt(e);
            setIsVisible(true); // Show install button
        };

        window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

        return () => {
            window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
        };
    }, []);

    const handleInstallClick = async () => {
        if (!deferredPrompt) return;

        // Show the prompt
        deferredPrompt.prompt();

        // Wait for the user to respond
        const { outcome } = await deferredPrompt.userChoice;
        console.log(`User response to install: ${outcome}`);

        // Clear the saved prompt
        setDeferredPrompt(null);
        setIsVisible(false);
    };

    return (
        <>
            {isVisible && (
                <button
                    onClick={handleInstallClick}
                    style={{
                        width: "320px",
                        backgroundColor: "white",   // Button background
                        borderRadius: 5,
                        border: "2px solid #779d38", // Green border
                        height: 50,
                        fontFamily: "Open Sans",
                        fontSize: 14,
                        color: "#779d38",           // Text color green
                        marginTop: "10px",
                        cursor: "pointer",           // Optional: make it feel clickable
                    }}
                >
                    Install App
                </button>
            )}
        </>
    );
}

export default InstallButton;
